export default "__VITE_ASSET__bb0ced9e__"